import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import Vendedor from './Vendedor'

const PasarelaPago = ({ itemsCompra }) => {
  const [comprasPorPagar, setComprasPorPagar] = useState([])

  useEffect(() => {
    const arrVendedores = []
    const uniqueVendedores = [...new Set(itemsCompra.map((item) => item.idVendedor))]

    uniqueVendedores.forEach((idVendedor) => {
      const pedidoItems = itemsCompra.filter((item) => item.idVendedor === idVendedor)

      arrVendedores.push({
        idComprador: parseInt(localStorage.getItem('idUsuario')),
        idVendedor,
        razonSocial: pedidoItems[0].razonSocial,
        calle: pedidoItems[0].calle,
        altura: pedidoItems[0].altura,
        celular: pedidoItems[0].celular,
        email: pedidoItems[0].email,
        telefono: pedidoItems[0].telefono,
        pedidoItems,
        totalAPagar: pedidoItems.reduce(
          (total, { precioUnitario, cantidad }) => total + precioUnitario * cantidad,
          0
        )
      })
    })
    setComprasPorPagar(arrVendedores)
  }, [itemsCompra])

  return comprasPorPagar.map((vendedor) => (
    <Vendedor key={vendedor.idVendedor} vendedor={vendedor} />
  ))
}

PasarelaPago.propTypes = {
  itemsCompra: PropTypes.array.isRequired
}

export default PasarelaPago
